// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__xMer6","show":"Modal_show__yV7y7","modal":"Modal_modal__Yxhzo"};